import { BaseThreeScene } from '@modules/three/common/BaseThreeScene';
import DevRoomService from '@bracesDesigner/devRoom/services/devRoomService.js';
import * as THREE from 'three';

export class DevRoomScene extends BaseThreeScene {
  constructor(container: HTMLElement) {
    super(container);
    this.root.camera.position.set(0, 0, 150);
  }

  public async init() {
    const service = new DevRoomService();
    this.startRendering();
    this.root.scene.add(new THREE.AmbientLight(0xffffff, 0.5));
    this.root.camera.position.set(0, 0, 15);
    const { gizmo, scene } = this.root;
    if (gizmo) {
      gizmo.detach();
      if (typeof gizmo.getHelper === 'function') {
        const helper = gizmo.getHelper();
        if (helper) scene.remove(helper);
      }
    }
  }
}
